import { BALANCE_FILL } from "../constants";
import type { CaptainBillingHistorySource } from "../types";

import { cn } from "@/lib/utils/cn";

export function BalanceSwatch({ source, className }: { source: CaptainBillingHistorySource; className?: string }) {
  return <span aria-hidden className={cn("inline-block size-2.5 shrink-0 rounded-full", BALANCE_FILL[source], className)} />;
}
